var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ldc-dropdown-menu"},[_c('div',{staticClass:"ldc-dropdown-content",style:(`height: ${_vm.height}px`)},[_c('div',{staticClass:"ldc-dropdown-slot"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }